import React, { useState } from 'react';
import axios from 'axios';
import loginLeftBg from '../images/login_left_bg.png';
const url = new URL(window.location.href);
const finalUrl = `/api/`;

export default function ForgotPassword() {
  const [resetEmail, setResetEmail] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    try {
      const frontendBaseUrl = window.location.origin;
      const response = await axios.post(
        finalUrl.concat('reset-password'),
        {
          username: resetEmail,
        },
        { headers: { 'X-Frontend-Base-Url': frontendBaseUrl } },
      );

      if (response.status === 200 && response.data.message) {
        alert(response.data.message);
      }
    } catch (error) {
      let errorMessage;
      if (error.response) {
        switch (error.response.status) {
          case 404:
            errorMessage =
              'User not found. Please check if the entered email is correct.';
            break;
          case 400:
            errorMessage =
              'Invalid request parameters. Please check the format of the entered email.';
            break;
          case 500:
            errorMessage = 'Internal server error. Please try again later.';
            break;
          default:
            errorMessage = `An unknown error occurred. Status code: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMessage =
          'Unable to connect to the server. Please check your network connection.';
      } else {
        errorMessage = `Error setting up the request: ${error.message}`;
      }
      alert(errorMessage);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="w-1/2 relative">
        <img
          src={loginLeftBg}
          alt="Education Platform"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-1/2 flex items-center justify-center h-screen">
        <div
          className="bg-white p-8 rounded-xl shadow-xl w-[400px]"
          onClick={(e) => e.stopPropagation()}
        >
          <h3 className="text-xl font-bold text-red-800 mb-4 text-center">
            Forgot Password
          </h3>
          <form onSubmit={handleForgotPassword}>
            <div className="mb-4">
              <input
                type="email"
                required
                placeholder="Enter your email address"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-red-600 focus:border-red-600 text-sm"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
            </div>
            <div className="flex flex-col space-x-4">
              <button
                type="submit"
                className="flex-1 py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-800 hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 !rounded-button whitespace-nowrap"
                style={{
                  borderRadius: '0.25rem',
                }}
              >
                Send Reset Link
              </button>
              <button
                type="button"
                //   style={{
                //     borderRadius: '0.375rem', // rounded-md
                //     border: '1px solid #d1d5db', // border-gray-300
                //   }}
                onClick={() => (window.location.href = '/login')}
                className="flex-1 py-3 px-4  text-sm font-medium text-red-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 !rounded-button whitespace-nowrap bg-white text-center"
              >
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
